export const ADD_PRODUCT = "PRODUCT/ADD_PRODUCT";
export const INCREASE_PRODUCT_QUANTITY_DYNAMICALY = "PRODUCT/INCREASE_PRODUCT_QUANTITY_DYNAMICALY";
export const INCREASE_PRODUCT_QUANTITY = "PRODUCT/INCREASE_PRODUCT_QUANTITY";
export const DECREASE_PRODUCT_QUANTITY = "PRODUCT/DECREASE_PRODUCT_QUANTITY";